import { Outlet } from 'react-router-dom'

import type { ReactElement } from 'react'

const ReviewsManagement = (): ReactElement => {
  return <Outlet />
}

export default ReviewsManagement
